import { rootActions, useAppDispatch, useAppSelector } from '../data/store';
import React from 'react';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const TabsNavigation = () => {

    const dispatch = useAppDispatch();
    const data = useAppSelector(store => store.root.data);
    const selectedTabId = useAppSelector(store => store.root.selectedTabId);

    const selectTab = (id: string, tabName: string, url?: string) => {
        if(url) {
            sendGAEvent('Top Menu', `${ tabName } > ${ tabName }`);

            window.location.href = url;
            return;
        }

        dispatch(
            rootActions.main({
                selectedTabId: id,
            })
        )
    };

    return (
        <div className="flex flex-col font-medium text-xs text-center text-white">

            {
                data?.topMenu.map(tab => {

                    const isSelected = selectedTabId === tab.id;

                    return (
                        <button
                            key={ tab.id }
                            type="button"
                            onClick={ () => {
                                selectTab(tab.id, tab.tabName, tab.url);
                            }}
                            className={ `top-menu-m__tab-btn flex flex-col items-center justify-center p-4 relative ${ isSelected ? 'top-menu-m__selected-tab-btn' : '' }` }>
                            <div dangerouslySetInnerHTML={{ __html: tab.tabIcon }} />
                            <span className="mt-2">{ tab.tabName }</span>
                        </button>
                    )
                })
            }
        </div>
    )
};

export default TabsNavigation;